import { notify } from '@affine/component';
import { usePluginOption } from '@udecode/plate/react';
import { PlaceholderPlugin, UploadErrorCode } from '@udecode/plate-media/react';
import * as React from 'react';

export const useUploadErrorToast = () => {
  const uploadError = usePluginOption(PlaceholderPlugin, 'error');

  React.useEffect(() => {
    if (!uploadError) return;

    const { code, data } = uploadError;

    switch (code) {
      case UploadErrorCode.INVALID_FILE_SIZE: {
        notify.error({
          title: `The size of files ${data.files
            .map(f => f.name)
            .join(', ')} is invalid`,
        });

        break;
      }
      case UploadErrorCode.INVALID_FILE_TYPE: {
        notify.error({
          title: `The type of files ${data.files
            .map(f => f.name)
            .join(', ')} is invalid`,
        });

        break;
      }
      case UploadErrorCode.TOO_LARGE: {
        notify.error({
          title: `The size of files ${data.files
            .map(f => f.name)
            .join(', ')} is too large than ${data.maxFileSize}`,
        });

        break;
      }
      case UploadErrorCode.TOO_LESS_FILES: {
        notify.error({
          title: `The mini um number of files is ${data.minFileCount} for ${data.fileType}`,
        });

        break;
      }
      case UploadErrorCode.TOO_MANY_FILES: {
        notify.error({
          title: `The maximum number of files is ${data.maxFileCount} ${
            data.fileType ? `for ${data.fileType}` : ''
          }`,
        });

        break;
      }
    }
  }, [uploadError]);
};

export const MediaUploadToast = () => {
  useUploadErrorToast();

  return null;
};
